<template>
  <custom-callout :has-border="false">
    <div class="row mx-auto p-4 font-weight-bold">
      {{ title }}
    </div>
    <template #edition>
      <div class="edition-template-container">
        <div class="row-container">
          <div
            v-for="(data, index) of results"
            :key="`row-sample-info-${index}`"
            asda
            class="rounded-bottom px-2 pt-2"
          >
            <div
              v-if="isEvaluationTherapySample"
              class="row mx-auto bg-white rounded p-3"
            >
              <div class="col font-weight-bold d-flex align-items-center">
                {{ data.companyName | empty }}
              </div>
              <div class="vertical-divider">&nbsp;</div>
              <div class="col text-center">
                <span class="color-gray-6 d-block font-14">
                  Lugares de Servicio
                </span>
                <span class="font-16 color-black">
                  {{ data.locationCount }}
                </span>
              </div>
              <div class="col text-center">
                <span class="color-gray-6 d-block font-14">
                  Especialistas
                </span>
                <span class="font-16 color-black">
                  {{ data.specialistCount }}
                </span>
              </div>
              <div class="col text-center">
                <span class="color-gray-6 d-block font-14">
                  Muestra Seleccionada (Estudiantes)
                </span>
                <span class="font-16 color-black">
                  {{ data.studentCount }}
                </span>
              </div>
            </div>
            <div
              v-if="isTransportationSample"
              class="row mx-auto bg-white rounded p-3"
            >
              <div class="col-2 font-weight-bold d-flex align-items-center">
                {{ data.regionName | empty }}
              </div>
              <div class="vertical-divider">&nbsp;</div>
              <div class="col pl-5">
                <span class="color-gray-6 d-block font-14">
                  Conteo de cuestionarios:
                </span>
                <span class="font-16 color-black">
                  {{ data.questionnaireCount | formatNumber }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="pl-1 mx-auto">
          <pagination
            v-if="showPagination"
            :data="pagination"
            show-text
            @pagination-go-page="goToPageHandler"
          />
        </div>
        <div class="p-2 mt-2">
          <div class="col-12 row mx-auto p-1 rounded text-center">
            <div
              class="col-1 total-title bg-white font-weight-bold rounded-left p-4"
            >
              Total
            </div>
            <div
              v-if="isEvaluationTherapySample"
              class="col d-flex align-items-center justify-content-center bg-money-green color-white"
            >
              <div class="col">
                <span class="d-block font-14">
                  Lugares de Servicio
                </span>
                <span class="font-18">
                  {{ locationCounter | formatNumber }}
                </span>
              </div>
            </div>
            <div
              v-if="isEvaluationTherapySample"
              class="col d-flex align-items-center justify-content-center bg-money-green color-white"
            >
              <div class="col">
                <span class="d-block font-14">
                  Especialistas
                </span>
                <span class="font-18">
                  {{ specialistCounter | formatNumber }}
                </span>
              </div>
            </div>
            <div
              v-if="isEvaluationTherapySample"
              class="col d-flex align-items-center justify-content-center bg-money-green color-white rounded-right"
            >
              <div class="col">
                <span class="d-block font-14">
                  Muestra Seleccionada ({{ individualType }})
                </span>
                <span class="font-18">
                  {{ studentCounter | formatNumber }}
                </span>
              </div>
            </div>
            <div
              v-if="isTransportationSample"
              class="col d-flex align-items-center bg-money-green color-white"
            >
              <div class="col text-left offset-1">
                <span class="d-block font-14">
                  Total
                </span>
                <span class="font-18">
                  {{ questionnaireCounter | formatNumber }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </custom-callout>
</template>

<script>
//libs components
import CustomCallout from 'custom-callout';
import Pagination from 'pagination';
import { questionnaireArea } from '@/utils/constants/questionnaireArea.js';
import { getSamplePrevisualization as _getSamplePrevisualization } from '@/modules/serviceSatisfactionQuestionnaire/api.js';
import { questionnaireSampleType } from '@/utils/constants/questionnaireSampleType.js';
//constants
const DEFAULT_PAGE_SIZE = 20;

export default {
  name: 'QuestionnaireCollapse',
  components: {
    CustomCallout,
    Pagination,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    sampleType: {
      type: Number,
      required: false,
      default: null,
    },
    areaId: {
      type: Number,
      required: false,
      default: null,
    },
    isTeacher: {
      type: Boolean,
      required: false,
      default: () => false,
    },
    academicYearId: {
      type: Number,
      required: false,
      default: () => null,
    },
    periodNumber: {
      type: Number,
      required: false,
      default: () => null,
    },
  },
  data() {
    return {
      results: [],
      locationCounter: 0,
      specialistCounter: 0,
      studentCounter: 0,
      questionnaireCounter: 0,
      pagination: {
        currentPage: 1,
        totalItemCount: 1,
        pageCount: 1,
        count: 1,
        pageSize: DEFAULT_PAGE_SIZE,
      },
    };
  },
  computed: {
    showPagination() {
      return this.pagination.totalItemCount > this.pagination.pageSize;
    },
    individualType() {
      return this.sampleType == this.sampleTypes.FamilyEvaluation ||
        this.sampleType == this.sampleTypes.FamilyTherapy
        ? 'Estudiantes'
        : 'Maestros';
    },
    sampleTypes() {
      return questionnaireSampleType;
    },
    isEvaluationTherapySample() {
      const tranportationTypes = [
        this.sampleTypes.FamilyTherapy,
        this.sampleTypes.FamilyEvaluation,
      ];
      return tranportationTypes.includes(this.sampleType);
    },
    isTransportationSample() {
      return this.areaId === questionnaireArea.Transportation;
    },
  },
  async mounted() {
    await this.fetchSamples();
  },
  methods: {
    async fetchSamples() {
      const payload = {
        pageIndex: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        sampleTypeId: this.sampleType,
        academicYearId: this.academicYearId,
        periodNumber: this.periodNumber,
        areaId: this.areaId,
        isTeacher: this.isTeacher,
      };

      const { data: result } = await _getSamplePrevisualization(payload);

      this.results = [...result.pagedGroups.data];

      this.locationCounter = result.computedLocations;
      this.specialistCounter = result.computedSpecialists;
      this.studentCounter = result.computedStudents;
      this.questionnaireCounter = result.computedQuestionnaires;

      this.pagination = {
        ...this.pagination,
        totalItemCount: result.pagedGroups.totalItemCount,
        pageCount: result.pagedGroups.pageCount,
        currentPage: result.pagedGroups.currentPage,
        count: result.pagedGroups.count,
      };
    },
    async goToPageHandler(pageIndex) {
      this.pagination.currentPage = pageIndex;
      await this.fetchSamples();
    },
  },
};
</script>
<style lang="scss" scoped>
$moneyGreen: #2db782;

.vertical-divider {
  border-left: 1px solid #dedede;
}
.total-title {
  border: 1px solid $moneyGreen;
  color: $moneyGreen;
}
.bg-money-green {
  background-color: $moneyGreen;
}
</style>
